export const applicationCountries = {
  fr: '🇫🇷',
  be: '🇧🇪',
  it: '🇮🇹',
  nl: '🇳🇱',
  de: '🇩🇪',
  at: '🇦🇹',
} as const
